<template>
  <div class="admin-dashboard">
  <h2>User Dashboard</h2>
  <!-- Admin CRUD Operations go here -->
  <div class="dashboard-links">
    <router-link to="/invoice-list" class="dashboard-link">Invoice List</router-link><br/>
  </div>
  </div>  
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue'
  import { useAuthStore } from '@/stores/authStore'
  
  export default defineComponent({
    setup() {
      const authStore = useAuthStore()
  
      return {
        userData: authStore.getUserData,
      }
    },
  })
  </script>
  
  <style scoped>
/* Container for the entire page */
.admin-dashboard {
  max-width: 800px;
  margin: 50px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  text-align: center;
}

/* Heading Styles */
.admin-dashboard h2 {
  font-size: 30px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}

/* Link container */
.dashboard-links {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Individual link styles */
.dashboard-link {
  display: inline-block;
  padding: 12px 20px;
  margin: 10px;
  background-color: #4CAF50; /* Green background for links */
  color: white;
  font-size: 18px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Hover effect for links */
.dashboard-link:hover {
  background-color: #45a049; /* Darker green on hover */
  transform: scale(1.05); /* Slight scaling effect */
}

/* Responsive design for smaller screens */
@media (max-width: 600px) {
  .admin-dashboard {
    padding: 15px;
  }

  .dashboard-link {
    font-size: 16px;
    padding: 10px 15px;
  }
}

</style>